export const environment = {  
  production: true,
  appBaseUrl: 'https://staging.friday.life',
  envName: 'uat'
};


// WEBPACK FOOTER //
// ./src/environments/environment.ts